import { CustomerCompanyType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const companyTypeMessages = defineMessages({
  agricultureOrMining: {
    defaultMessage: 'Agriculture / Mining',
    description: 'company type title',
  },
  construction: {
    defaultMessage: 'Construction',
    description: 'company type title',
  },
  education: {
    defaultMessage: 'Education',
    description: 'company type title',
  },
  finance: {
    defaultMessage: 'Finance / Banking',
    description: 'company type title',
  },
  governmentOrBumn: {
    defaultMessage: 'Government / BUMN',
    description: 'company type title',
  },
  healthcare: {
    defaultMessage: 'Healthcare',
    description: 'company type title',
  },
  manufacturing: {
    defaultMessage: 'Manufacturing',
    description: 'company type title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'company type title',
  },
  services: {
    defaultMessage: 'Services',
    description: 'company type title',
  },
  technology: {
    defaultMessage: 'Technology',
    description: 'company type title',
  },
  tradeOrRetail: {
    defaultMessage: 'Trade / Retail',
    description: 'company type title',
  },
  transportation: {
    defaultMessage: 'Transportation',
    description: 'company type title',
  },
})

export function translateCompanyType(intl: IntlShape, companyType: CustomerCompanyType): string {
  switch (companyType) {
    case CustomerCompanyType.AGRICULTURE_OR_MINING:
      return intl.formatMessage(companyTypeMessages.agricultureOrMining)
    case CustomerCompanyType.CONSTRUCTION:
      return intl.formatMessage(companyTypeMessages.construction)
    case CustomerCompanyType.EDUCATION:
      return intl.formatMessage(companyTypeMessages.education)
    case CustomerCompanyType.FINANCE:
      return intl.formatMessage(companyTypeMessages.finance)
    case CustomerCompanyType.GOVERNMENT_OR_BUMN:
      return intl.formatMessage(companyTypeMessages.governmentOrBumn)
    case CustomerCompanyType.HEALTHCARE:
      return intl.formatMessage(companyTypeMessages.healthcare)
    case CustomerCompanyType.MANUFACTURING:
      return intl.formatMessage(companyTypeMessages.manufacturing)
    case CustomerCompanyType.OTHER:
      return intl.formatMessage(companyTypeMessages.other)
    case CustomerCompanyType.SERVICES:
      return intl.formatMessage(companyTypeMessages.services)
    case CustomerCompanyType.TECHNOLOGY:
      return intl.formatMessage(companyTypeMessages.technology)
    case CustomerCompanyType.TRADE_OR_RETAIL:
      return intl.formatMessage(companyTypeMessages.tradeOrRetail)
    case CustomerCompanyType.TRANSPORTATION:
      return intl.formatMessage(companyTypeMessages.transportation)
  }
}
